import { configureStore } from "@reduxjs/toolkit";

import authReducers from "../features/authSlice";
import ProfileSlice from "../features/profileSlice";
import otpReducers from "../features/OTPSlice";
import RoleSlice from "../features/RoleSlice";
import userSlice from "../features/userSlice";
import FakultasSlice from "../features/FakultasSlice";
import LayananSlice from "../features/LayananSlice";
import ProdiSlice from "../features/ProdiSlice";
import MenuSlice from "../features/MenuSlice";
import DokumenSlice from "../features/DokumenSlice";
import LayananDokumenSlice from "../features/layananDokumenSlice";
import LayananFieldSlice from "../features/LayananFieldSlice";
import LayananKodepaySlice from "../features/layananKodepay";
import KodepayVASlice from "../features/kodepayVASlice";
import KodeAkunSlice from "../features/KodeAkunSlice";
import PembayaranVASlice from "../features/pembayaran_va/PembayaranVASlice";
import PermohonanSlice from "../features/permohonan/PermohonanSlice";
import TimelineSlice from "../features/permohonan/TimelineSlice";
import JenisPembiayaanSlice from "../features/jenisPembiayaanSlice";
import JenisPembiayaanDokumenSlice from "../features/jenisPembiayaanDokumenSlice";
import PraktikumSlice from "../features/praktikum/PraktikumSlice";
import CashflowSlice from "../features/cashflow/CashflowSlice";
import SurveySlice from "../features/SurveySlice";
import SurveyUserSlice from "../features/survey_user/SurveyUserSlice";
import ImportMutasiBankSlice from "../features/importMutasiBank/ImportMutasiBankSlice";
import ConfigSemesterSlice from "../features/config/ConfigSemesterSlice";
import MadingSlice from "../features/mading/MadingSlice";
import StaffMenuSlice from "../features/StaffMenuSlice";
import UserDiscountSlice from "../features/UserDiscountSlice";

export const store = configureStore({
  reducer: {
    auth: authReducers,
    profile: ProfileSlice,
    otp: otpReducers,
    user: userSlice,
    fakultas: FakultasSlice,
    role: RoleSlice,
    layanan: LayananSlice,
    prodi: ProdiSlice,
    menu: MenuSlice,
    dokumen: DokumenSlice,
    layananDokumen: LayananDokumenSlice,
    layananField: LayananFieldSlice,
    layananKodepay: LayananKodepaySlice,
    kodepayVA: KodepayVASlice,
    kodeAkun: KodeAkunSlice,
    pembayaranVA: PembayaranVASlice,
    permohonan: PermohonanSlice,
    timeline: TimelineSlice,
    jenisPembiayaan: JenisPembiayaanSlice,
    jenisPembiayaanDokumen: JenisPembiayaanDokumenSlice,
    praktikum: PraktikumSlice,
    cashflow: CashflowSlice,
    survey: SurveySlice,
    surveyUser: SurveyUserSlice,
    importMutasiBank: ImportMutasiBankSlice,
    configSemester: ConfigSemesterSlice,
    mading: MadingSlice,
    staffMenu: StaffMenuSlice,
    userDiscount: UserDiscountSlice,
  },
});
